var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.3335H2.66634C1.93301 1.3335 1.33967 1.9335 1.33967 2.66683L1.33301 14.6668L3.99967 12.0002H13.333C14.0663 12.0002 14.6663 11.4002 14.6663 10.6668V2.66683C14.6663 1.9335 14.0663 1.3335 13.333 1.3335ZM5.99967 7.3335H4.66634V6.00016H5.99967V7.3335ZM8.66634 7.3335H7.33301V6.00016H8.66634V7.3335ZM11.333 7.3335H9.99967V6.00016H11.333V7.3335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureSms);
export default __webpack_public_path__ + "static/media/signature-sms.7cf1f5b784b97bb2aed287189f2c483a.svg";
export { ForwardRef as ReactComponent };